import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BiTimeChart } from '@/features/dashboard-finance/charts/BiTimeChart';
import { formatInt } from '@/features/dashboard-finance/formatters';
import type { TtfBucket } from './useProduct';

const ORDER: TtfBucket[] = ['LT_1H', 'D_1H_24H', 'D_1_7D', 'D_8_30D', 'GT_30D', 'NEVER'];

/** Histograma de tenants por tempo entre criação e primeira etiqueta (buckets de `useProduct`). */
export function TimeToFirstLabelHistogram({
  buckets,
}: {
  buckets: Record<TtfBucket, number>;
}): React.JSX.Element {
  const { t } = useTranslation();
  const data = ORDER.map((b) => ({ x: t(`product.ttf.${b}`), y: buckets[b] }));
  return (
    <BiTimeChart
      title={t('product.charts.ttf')}
      subtitle={t('product.charts.ttfHint')}
      type="bar"
      data={data}
      color="#0ea5e9"
      valueFormatter={(v): string => formatInt(v)}
    />
  );
}
